// extracted by mini-css-extract-plugin
module.exports =  {"info":"_93444fe79c--info--JAvte","data":"_93444fe79c--data--Nd83q","logo":"_93444fe79c--logo--my1AX"};